import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataQueryButtonDataConfigComponent } from './data-query-button-data-config.component';
import { DataQueryButtonDisplayConfigComponent } from '../display/data-query-button-display-config.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        DataQueryButtonDisplayConfigComponent,
        DataQueryButtonDataConfigComponent
    ],
    exports: [
        DataQueryButtonDisplayConfigComponent,
        DataQueryButtonDataConfigComponent,
    ]
})
export class DataQueryButtonConfigModule { }
